export enum enumEntrySummaryQuickFixStep {
  MAIN_SHIPMENT_DETAILS,
  SHIPMENT_TYPE_DETAILS,
  BILL_OF_LADING_DETAILS,
  SELLER_AND_CONSIGNEE_DETAILS,
  SHIPPING_TERMS_OF_SALE,
  INVOICE_MAIN_DETAILS,
  MANUFACTURER,
  LINE_ITEM,
  NEW_LINE_ITEM,
}
